<template>
  <vs-popup fullscreen class="rm-order-po-pdf-popup"
            id="rm-order-po-pdf-pop-up"
            :title="`${order_code} ORDER CONFIRMATION`"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <div class="vx-row mb-8">
        <div class="vx-col">
          <div class="flex">
            <div class="flex">
              <vs-button @click="onClickPrint()" color="warning" type="border" >Print</vs-button>
              <vs-button  @click.stop="generateReportPromtActive()"  class="ml-2" color="dark" type="border" >Send</vs-button>
            </div>
          </div>
        </div>
      </div>

      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="false"
        :filename="'SALES_ORDER_CONFIRMATION_'+invoice_data.order_code"
        :pdf-quality="2"
        :manual-pagination="false"
        :paginate-elements-by-height="1400"
        pdf-format="a4"
        pdf-orientation="portrait"
        ref="html2Pdf"
        pdf-content-width="100%"
        :html-to-pdf-options="htmlToPdfOptions"
        @beforeDownload="pdfBeforeDownloaded($event)"
      >
        <section slot="pdf-content"
        style="display: flex; flex-wrap: wrap; padding: 15px;">
          <body id="myelement">
          <div id="full-wrap">


            <main class="clearfix">

              <div id="user" class="clearfix">

                <div id="user-top">

                  <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">

                    <tbody>
                    <tr>
                      <td class="head align-left">
                        <img id="logo"
                             src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/ITS-Logo.png"
                             alt="Logo" width="300" height="150" />
                      </td>


                    </tr>


                    <tr>
                      <td>
                        <table id="main-tbl">
                          <thead class="">
                          <tr>
                            <td colspan="2" class="head">
                              <h4 class="m-0" style="color: #000000"><b>SALES ORDER CONFIRMATION</b></h4>
                            </td>
                          </tr>
                          </thead>

                          <tbody>

                          <tr>

                            <td class="toptd bd-b-0 bd-r-0">
                              <table id="in-tbl">
                                <thead>
                                <tr>
                                  <td colspan="2" class="headtd">
                                    <div>
                                      <p class="sml">SHIPPER/EXPORTER</p>
                                    </div>
                                  </td>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                  <td class="bodytda">
                                    <div>
                                      <p class="sml">
                                        {{ invoice_data.shipper_address.company_name }}<br>
                                        {{ invoice_data.shipper_address.line_1 }}<br>
                                        {{ invoice_data.shipper_address.line_2 }}<br>
                                        {{ invoice_data.shipper_address.town_state }}<br>
                                        {{ invoice_data.shipper_address.post_code }}<br>
                                        {{ invoice_data.shipper_address.country }}</p>
                                    </div>
                                  </td>
                                  <td class="bodytdb">
                                    <div>
                                      <p class="sml">Tel. {{ invoice_data.tel || '' }}<br>
                                        Email: {{ invoice_data.email || '' }}<br>
                                        VAT Reg No: {{ invoice_data.vat_reg || '' }}<br>
                                        Company No: {{ invoice_data.company_no || '' }}<br>
                                        EORI for NL: {{ invoice_data.eori_ni || '' }}<br>
                                        EORI for EU: {{ invoice_data.eori_eu || '' }}</p>
                                    </div>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </td>
                            <td class="toptd bd-b-0 bd-l-0">
                              <table id="in-tbl">
                                <tr>
                                  <td>
                                    <div>
                                      <p class="sml">ORDER DATE:</p>
                                      <p class="sml"><b>{{ __dateTimeFormatterToDate(invoice_data.created_at) }}</b></p><br>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <p class="sml">ITS ORDER NUMBER:</p>
                                      <p class="sml"><b>{{ invoice_data.order_code }}</b></p>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div>
                                      <p class="sml">CUSTOMER ACCOUNT NUMBER:</p>
                                      <p class="sml"><b>{{ invoice_data.customer_account_number }}</b></p><br>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <p class="sml">CUSTOMER PO NUMBER:</p>
                                      <p class="sml"><b>{{ invoice_data.customer_order_number  }}</b></p>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>

                            <td class="toptd bd-b-0 bd-r-0">
                              <table id="in-tbl">
                                <thead>
                                <tr>
                                  <td colspan="2" class="headtd">
                                    <div>
                                      <p class="sml">CONSIGNEE/RECEIVER</p>
                                    </div>
                                  </td>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                  <td class="bodytda">
                                    <div>
                                      <p class="sml">
                                        {{ invoice_data.customer_address.company_name }}<br>
                                        {{ invoice_data.customer_address.line_1 }}<br>
                                        {{ invoice_data.customer_address.line_2 }}<br>
                                        <span v-if="invoice_data.customer_address.line_3 !== 'N/A'">{{ invoice_data.customer_address.line_3 }}<br></span>
                                        {{ invoice_data.customer_address.town_state }}<br>
                                        {{ invoice_data.customer_address.post_code }}<br>
                                        {{ invoice_data.customer_address.country }}</p>
                                    </div>
                                  </td>
                                  <td class="bodytdb">
                                    <div>
                                      <p class="sml">
                                        VAT: {{ invoice_data.consignee_vat || 'N/A' }}<br>
                                        EORI: {{ invoice_data.consignee_eori || 'N/A' }}<br>
                                        TEL: {{ invoice_data.consignee_tel || '' }}<br>
                                        IMPORT LICENCE NO: {{ invoice_data.import_licence_no || 'N/A' }}</p>
                                    </div>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </td>
                            <td class="toptd bd-b-0 bd-l-0">
                              <table id="in-tbl">
                                <tr>
                                  <td>
                                    <div>
                                      <p class="sml">INCOTERMS:</p>
                                      <p class="sml"><b>{{ invoice_data.incoterm }}</b></p><br>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <p class="sml">TRANSPORT AWB/REF NUMBER:</p>
                                      <p class="sml"><b>{{  invoice_data.transport_ref_number }}</b></p>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div>
                                      <p class="sml">TERMS OF PAYMENT:</p>
                                      <p class="sml">
                                        <b v-if="!is_proforma_account">{{ invoice_data.terms_of_payment ? `${invoice_data.terms_of_payment} Days` : 'N/A' }}</b>
                                        <b v-if="is_proforma_account">Payment upon receipt</b>
                                      </p>
                                    </div>
                                  </td>
                                  <td>
                                    <div>
                                      <p class="sml">CURRENCY</p>
                                      <p class="sml">
                                        <b> {{ invoice_data.account_currency }} </b>
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>

                            <td class="toptd bd-r-0">
                              <table id="in-tbl">
                                <thead>
                                <tr>
                                  <td colspan="2" class="headtd">
                                    <div>
                                      <p class="sml">DELIVERY SITE</p>
                                    </div>
                                  </td>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                  <td class="bodytd">
                                    <div>
                                      <p class="sml">
                                        {{ invoice_data.delivery_address.company_name }}<br>
                                        {{ invoice_data.delivery_address.line_1 }}<br>
                                        {{ invoice_data.delivery_address.line_2 }}<br>
                                        {{ invoice_data.delivery_address.town_state }}<br>
                                        {{ invoice_data.delivery_address.post_code }}<br>
                                        {{ invoice_data.delivery_address.country }}
                                      </p>
                                    </div>
                                  </td>

                                </tr>
                                </tbody>
                              </table>
                            </td>
                            <td class="toptd bd-l-0">
                              <table id="in-tbl">
                                <thead>
                                <tr>
                                  <td colspan="2" class="headtd">
                                    <div>
                                      <p class="sml">DELIVERY INSTRUCTIONS</p>
                                    </div>
                                  </td>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                  <td class="bodytda">
                                    {{ invoice_data.delivery_instruction }}
                                  </td>
                                  <td class="bodytdb">
                                    <!--                                <div>-->
                                    <!--                                  <p class="sml">Tel. 01635 261920<br>-->
                                    <!--                                    Email: sales@itstaste.com<br>-->
                                    <!--                                    VAT Reg No: 1234567890<br>-->
                                    <!--                                    Company No: 1234567890<br>-->
                                    <!--                                    EORI for NL: XI1234567890<br>-->
                                    <!--                                    EORI for EU: GB1234567890</p>-->
                                    <!--                                </div>-->
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </td>
                          </tr>
                          <tr>

                            <td colspan="2" class="toptd">
                              <table id="content-tbl">
                                <thead>
                                <tr>
                                  <th><b>Delivery Date</b></th>
                                  <th><b>Customer Product Code</b></th>
                                  <th><b>Product Code/Name</b></th>
                                  <th><b>Quantity(KG)</b></th>
                                  <th><b>Commodity Code</b></th>
                                  <th><b>Country of Origin</b></th>
                                  <th><b>Price Per Unit ({{ invoice_data.account_currency }})</b></th>
                                  <th width="10%"><b>VAT Rate</b></th>
                                  <th><b>Net Value ({{ invoice_data.account_currency }})</b></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item, index) in invoice_data.order_items" :key="index">

                                  <td>{{ item.delivery_date }}</td>

                                  <td>{{ item.customer_product_code }}</td>

                                  <td>{{ item.product_name_code }}</td>

                                  <td>{{ Number(item.quantity) }}</td>
                                  <td>{{ item.commodity_code }}</td>

                                  <td>{{ item.origin }}</td>

                                  <td>{{item.price}}</td>

                                  <td>{{ Number(item.vat_value).toFixed(2) }}</td>

                                  <td>{{ Number(item.net_value).toFixed(2) }}</td>

                                </tr>
                                <tr>
                                  <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                                  <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                                  <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                                  <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                                  <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                                  <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                                  <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                                  <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                                  <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>

                                </tr>

                                <tr v-for="(cost, index_add_cost) in invoice_data.add_costs" :key="index_add_cost">
                                  <td style="text-align: left" colspan="7">{{ cost.name || '' }}</td>
                                  <td >{{ Number(cost.vat_percent).toFixed(2) }}</td>
                                  <td rowspan="1">{{ Number(cost.amount * (1 + (Number(cost.vat_percent) / 100))).toFixed(2) }}</td>
                                </tr>

                                <tr>
                                  <td colspan="7" rowspan="4">&nbsp;</td>
                                  <td>Item Net Value</td>
                                  <td>{{ itemNetValue() }}</td>
                                </tr>
                                <!--                            <tr>-->
                                <!--                              <td>Frieght Cost (20.00%)</td>-->
                                <!--                              <td>12.00</td>-->
                                <!--                            </tr>-->
                                <tr v-for="(cost, index_cost) in invoice_data.additional_costs" :key="index_cost">
                                  <td>{{ cost.name }} ({{ cost.percent }}% VAT/Tax)</td>
                                  <td>{{ Number(cost.amount).toFixed(2) }}</td>
                                </tr>
                                <tr>
                                  <td>Total Order Value <br>(Incl. VAT in {{ invoice_data.account_currency }})</td>
                                  <td>{{ totalOrderValue() }}</td>
                                </tr>

                                </tbody>
                              </table>
                            </td>

                          </tr>

                          <tr>
                            <td colspan="2" class="toptd">

                              <table class="no-bd-tbl">
                                <thead>
                                <tr>
                                  <td colspan="4">
                                    <p>
                                      <br>
                                      The exporter of the products covered by this<br>
                                      document declares that, except where<br>
                                      otherswise clearly indicated, these products
                                      are<br>
                                      of the UK preferential origin<br>
                                      <b>Products: Not edible, Not animal origin
                                      </b>
                                    </p>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="1" style="vertical-align: bottom;">
                                    <p>Payment Details<br>
                                      Sterling Electronic Payments:-<br>
                                      Bank: {{ invoice_data.bank_details.name }}<br>
                                      Account Name: {{ invoice_data.bank_details.account_name }}<br>
                                      Account Number: {{ invoice_data.bank_details.account_number }} Sort Code: {{ invoice_data.bank_details.sort_code || 'N/A' }}<br>
                                      IBAN: {{ invoice_data.bank_details.iban || 'N/A' }}<br>
                                      SWIFTBIC: {{ invoice_data.bank_details.swiftbi || 'N/A' }}</p>

                                  </td>
                                  <td colspan="2" class="text-center" style="vertical-align: bottom;">
                                    <p style="vertical-align: text-bottom;">www.itstaste.com</p>
                                  </td>
                                  <td colspan="1" style="vertical-align: bottom;">
                                    <p class="align-left">ITS reserves the right to
                                      charge
                                      interest on late payments<br>
                                      ITS terms and conditions of sale apply.</p>
                                  </td>
                                </tr>
                                </thead>
                              </table>
                            </td>

                          </tr>


                          </tbody>
                        </table>
                      </td>
                    </tr>









                    </tbody>
                  </table>



                </div>

              </div>

            </main>



          </div>
          </body>
        </section>
      </vue-html2pdf>



      <body id="myelement">
      <div id="full-wrap">


        <main class="clearfix">

          <div id="user" class="clearfix">

            <div id="user-top">

              <table bgcolor="#fff" border="0" cellspacing="0" cellpadding="0">

                <tbody>
                <tr>
                  <td class="head align-left">
                    <img id="logo"
                         src="https://nimble-laravel-dev.s3.eu-west-2.amazonaws.com/images/ITS-Logo.png"
                         alt="Logo" width="300" height="150" />
                  </td>


                </tr>


                <tr>
                  <td>
                    <table id="main-tbl">
                      <thead class="">
                      <tr>
                        <td colspan="2" class="head">
                          <h4 class="m-0" style="color: #000000"><b>SALES ORDER CONFIRMATION</b></h4>
                        </td>
                      </tr>
                      </thead>

                      <tbody>

                      <tr>

                        <td class="toptd bd-b-0 bd-r-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">SHIPPER/EXPORTER</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.shipper_address.company_name }}<br>
                                    {{ invoice_data.shipper_address.line_1 }}<br>
                                    {{ invoice_data.shipper_address.line_2 }}<br>
                                    {{ invoice_data.shipper_address.town_state }}<br>
                                    {{ invoice_data.shipper_address.post_code }}<br>
                                    {{ invoice_data.shipper_address.country }}</p>
                                </div>
                              </td>
                              <td class="bodytdb">
                                <div>
                                  <p class="sml">Tel. {{ invoice_data.tel || '' }}<br>
                                    Email: {{ invoice_data.email || '' }}<br>
                                    VAT Reg No: {{ invoice_data.vat_reg || '' }}<br>
                                    Company No: {{ invoice_data.company_no || '' }}<br>
                                    EORI for NL: {{ invoice_data.eori_ni || '' }}<br>
                                    EORI for EU: {{ invoice_data.eori_eu || '' }}</p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-b-0 bd-l-0">
                          <table id="in-tbl">
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">ORDER DATE:</p>
                                  <p class="sml"><b>{{ __dateTimeFormatterToDate(invoice_data.created_at) }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">ITS ORDER NUMBER:</p>
                                  <p class="sml"><b>{{ invoice_data.order_code }}</b></p>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">CUSTOMER ACCOUNT NUMBER:</p>
                                  <p class="sml"><b>{{ invoice_data.customer_account_number }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">CUSTOMER PO NUMBER:</p>
                                  <p class="sml"><b>{{ invoice_data.customer_order_number  }}</b></p>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>

                        <td class="toptd bd-b-0 bd-r-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">CONSIGNEE/RECEIVER</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.customer_address.company_name }}<br>
                                    {{ invoice_data.customer_address.line_1 }}<br>
                                    {{ invoice_data.customer_address.line_2 }}<br>
                                    <span v-if="invoice_data.customer_address.line_3">{{ invoice_data.customer_address.line_3 }}<br></span>
                                    {{ invoice_data.customer_address.town_state }}<br>
                                    {{ invoice_data.customer_address.post_code }}<br>
                                    {{ invoice_data.customer_address.country }}</p>
                                </div>
                              </td>
                              <td class="bodytdb">
                                <div>
                                  <p class="sml">
                                    VAT: {{ invoice_data.consignee_vat || 'N/A' }}<br>
                                    EORI: {{ invoice_data.consignee_eori || 'N/A' }}<br>
                                    TEL: {{ invoice_data.consignee_tel || '' }}<br>
                                    IMPORT LICENCE NO: {{ invoice_data.import_licence_no || 'N/A' }}</p>
                                </div>
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-b-0 bd-l-0">
                          <table id="in-tbl">
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">INCOTERMS:</p>
                                  <p class="sml"><b>{{ invoice_data.incoterm }}</b></p><br>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">TRANSPORT AWB/REF NUMBER:</p>
                                  <p class="sml"><b>{{  invoice_data.transport_ref_number }}</b></p>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div>
                                  <p class="sml">TERMS OF PAYMENT:</p>
                                  <p class="sml">
                                    <b v-if="!is_proforma_account">{{ invoice_data.terms_of_payment ? `${invoice_data.terms_of_payment} Days` : 'N/A' }}</b>
                                    <b v-if="is_proforma_account">Payment upon receipt</b>
                                  </p>
                                </div>
                              </td>
                              <td>
                                <div>
                                  <p class="sml">CURRENCY</p>
                                  <p class="sml">
                                    <b> {{ invoice_data.account_currency }} </b>
                                  </p>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>

                        <td class="toptd bd-r-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">DELIVERY SITE</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytd">
                                <div>
                                  <p class="sml">
                                    {{ invoice_data.delivery_address.company_name }} <br>
                                    {{ invoice_data.delivery_address.line_1 }}<br>
                                    {{ invoice_data.delivery_address.line_2 }}<br>
                                    <span v-if="invoice_data.delivery_address.line_3 !== 'N/A'">{{ invoice_data.delivery_address.line_3 }}<br></span>
                                    {{ invoice_data.delivery_address.town_state }}<br>
                                    {{ invoice_data.delivery_address.post_code }}<br>
                                    {{ invoice_data.delivery_address.country }}
                                  </p>
                                </div>
                              </td>

                            </tr>
                            </tbody>
                          </table>
                        </td>
                        <td class="toptd bd-l-0">
                          <table id="in-tbl">
                            <thead>
                            <tr>
                              <td colspan="2" class="headtd">
                                <div>
                                  <p class="sml">DELIVERY INSTRUCTIONS</p>
                                </div>
                              </td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                              <td class="bodytda">
                                {{ invoice_data.delivery_instruction }}
                              </td>
                              <td class="bodytdb">
<!--                                <div>-->
<!--                                  <p class="sml">Tel. 01635 261920<br>-->
<!--                                    Email: sales@itstaste.com<br>-->
<!--                                    VAT Reg No: 1234567890<br>-->
<!--                                    Company No: 1234567890<br>-->
<!--                                    EORI for NL: XI1234567890<br>-->
<!--                                    EORI for EU: GB1234567890</p>-->
<!--                                </div>-->
                              </td>
                            </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      <tr>

                        <td colspan="2" class="toptd">
                          <table id="content-tbl">
                            <thead>
                            <tr>
                              <th><b>Delivery Date</b></th>
                              <th><b>Customer Product Code</b></th>
                              <th><b>Product Code/Name</b></th>
                              <th><b>Quantity(KG)</b></th>
                              <th><b>Commodity Code</b></th>
                              <th><b>Country of Origin</b></th>
                              <th><b>Price Per Unit ({{ invoice_data.account_currency }})</b></th>
                              <th width="10%"><b>VAT Rate</b></th>
                              <th><b>Net Value ({{ invoice_data.account_currency }})</b></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in invoice_data.order_items" :key="index">

                              <td>{{ item.delivery_date }}</td>

                              <td>{{ item.customer_product_code }}</td>

                              <td>{{ item.product_name_code }}</td>

                              <td>{{ Number(item.quantity) }}</td>
                              <td>{{ item.commodity_code }}</td>

                              <td>{{ item.origin }}</td>

                              <td>{{item.price}}</td>

                              <td>{{ Number(item.vat_value).toFixed(2) }}</td>

                              <td>{{ Number(item.net_value).toFixed(2) }}</td>

                            </tr>
                            <tr>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                              <td v-bind:style="styleObject" rowspan="1">&nbsp;</td>
                            </tr>

                            <tr v-for="(cost, index_add_cost) in invoice_data.add_costs" :key="index_add_cost">
                              <td class="text-left" colspan="7">{{ cost.name || '' }}</td>
                              <td >{{ Number(cost.vat_percent).toFixed(2) }}</td>
                              <td rowspan="1">{{ Number(cost.amount * (1 + (Number(cost.vat_percent) / 100))).toFixed(2) }}</td>
                            </tr>

                            <tr>
                              <td colspan="7" rowspan="4">&nbsp;</td>
                              <td>Item Net Value</td>
                              <td>{{ itemNetValue() }}</td>
                            </tr>
<!--                            <tr>-->
<!--                              <td>Frieght Cost (20.00%)</td>-->
<!--                              <td>12.00</td>-->
<!--                            </tr>-->
                            <tr v-for="(cost, index_cost) in invoice_data.additional_costs" :key="index_cost">
                              <td>{{ cost.name }} ({{ cost.percent }}% VAT/Tax)</td>
                              <td>{{ Number(cost.amount).toFixed(2) }}</td>
                            </tr>
                            <tr>
                              <td>Total Order Value <br>(Incl. VAT in {{ invoice_data.account_currency }})</td>
                              <td>{{ totalOrderValue() }}</td>
                            </tr>

                            </tbody>
                          </table>
                        </td>

                      </tr>

                      <tr>
                        <td colspan="2" class="toptd">

                          <table class="no-bd-tbl">
                            <thead>
                            <tr>
                              <td colspan="4">
                                <p>
                                  <br>
                                  The exporter of the products covered by this<br>
                                  document declares that, except where<br>
                                  otherswise clearly indicated, these products
                                  are<br>
                                  of the UK preferential origin<br>
                                  <b>Products: Not edible, Not animal origin
                                  </b>
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="1" style="vertical-align: bottom;">
                                <p>Payment Details<br>
                                  Sterling Electronic Payments:-<br>
                                  Bank: {{ invoice_data.bank_details.name }}<br>
                                  Account Name: {{ invoice_data.bank_details.account_name }}<br>
                                  Account Number: {{ invoice_data.bank_details.account_number }} Sort Code: {{ invoice_data.bank_details.sort_code || 'N/A' }}<br>
                                  IBAN: {{ invoice_data.bank_details.iban || 'N/A' }}<br>
                                  SWIFTBIC: {{ invoice_data.bank_details.swiftbi || 'N/A' }}</p>

                              </td>
                              <td colspan="2" class="text-center" style="vertical-align: bottom;">
                                <p style="vertical-align: text-bottom;">www.itstaste.com</p>
                              </td>
                              <td colspan="1" style="vertical-align: bottom;">
                                <p class="align-left">ITS reserves the right to
                                  charge
                                  interest on late payments<br>
                                  ITS terms and conditions of sale apply.</p>
                              </td>
                            </tr>
                            </thead>
                          </table>
                        </td>

                      </tr>


                      </tbody>
                    </table>
                  </td>
                </tr>









                </tbody>
              </table>



            </div>

          </div>

        </main>



      </div>
      </body>
    </vx-card>

    <vs-prompt
      @cancel="customer_email=''"
      @accept="generateReport"
      @close="activePrompt = false"
      :title="'Select customer user email to send'"
      :accept-text="'Confirm'"
      :color="'primary'"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Select user email</span>
        <v-select
          :clearable="true" name="customerId" placeholder=""
          v-model="customer_email"
          label="email"
          :options="customer_list"
          :reduce="option => option.email"
          :dir="$vs.rtl ? 'rtl' : 'ltr'">
          <template v-slot:option="option">
              <span>{{option.email}} ( {{option.job_title || 'N/A'}} ) </span>
          </template>
          </v-select>
      </div>
    </vs-prompt>

  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const CustomerRepository = RepositoryFactory.get('customer')
  const FileRepository = RepositoryFactory.get('file');
  const DropDownRepository = RepositoryFactory.get('drop_down')

  import { Printd } from 'printd'
  import VueHtml2pdf from 'vue-html2pdf'

  import {mapActions, mapGetters} from "vuex";

  function initialState() {
    return {
      open: false,
      activePrompt: false,
      customer_list: [],
      customer_email: '',
      id: '',
      product_order_secret_code: '',
      data: {},
      order_code: '',
      status_name: '',
      is_proforma_account: false,
      invoice_data: {
        order_items: [],
        additional_costs: [],
        add_costs: [],
        tel: '',
        bank_details: {
          name: '',
          account_name: '',
          account_number: '',
          iban: '',
          sort_code: '',
          swiftbi: ''
        },
        shipper_address: {
          company_name: '',
          line_1: '',
          line_2: '',
          line_3: '',
          town_state: '',
          post_code: '',
          country: '',
        },
        customer_address: {
          company_name: '',
          line_1: '',
          line_2: '',
          line_3: '',
          town_state: '',
          post_code: '',
          country: '',
        },
        invoice_address: {
          company_name: '',
          line_1: '',
          line_2: '',
          line_3: '',
          town_state: '',
          post_code: '',
          country: '',
        },
        delivery_address: {
          company_name: '',
          line_1: '',
          line_2: '',
          line_3: '',
          town_state: '',
          post_code: '',
          country: '',
        }
      },
      order_details: {
        supplier_address: {
          name: '',
          line1: '',
          line2: '',
          line3: '',
          town_state: '',
          post_code: '',
          country: ''
        },
        deliver_to: {
          name: '',
          line1: '',
          line2: '',
          line3: '',
          town_state: '',
          post_code: '',
          country: ''
        },
        invoice_to: {
          name: '',
          line1: '',
          line2: '',
          line3: '',
          town_state: '',
          post_code: '',
          country: ''
        },
        order_date: '',
        order_number: '',
        items: [],
        delivery_instruction: '',
        generated_on: ''
      },
      htmlToPdfOptions: {
        margin: 0,
        image: {
          type: 'jpeg',
          quality: 0.98
        },
        enableLinks: false,
        html2canvas: {
          scale: 2,
          useCORS: true
        },
        jsPDF: {
          unit: 'in',
          format: 'a4',
          orientation: 'portrait'
        }
      }
    }
  }

  export default {
    name: 'ProductOrderConfirmationPdfPopUp',
    data () {
      return initialState()
    },
    computed: {
      styleObject: function () {
        const total_item_height = this.invoice_data.order_items.length * 55
        const total_add_cost_line_height =  0
        const space_height = 350 - (total_item_height + total_add_cost_line_height)
        return {
          height: `${space_height}px`
        }
      }
    },
    methods:{
      async openPopup (id, order_code, status_name, is_proforma_account, product_order_secret_code) {
        try {
          await Object.assign(this.$data, initialState())
          this.id = id
          this.product_order_secret_code = product_order_secret_code
          this.order_code = order_code
          this.status_name = status_name
          this.is_proforma_account = is_proforma_account
          this.open = true
          await this.getInvoiceDetails()
        } catch (error) {

        }
      },
      itemNetValue() {
        if (!this.invoice_data || !Array.isArray(this.invoice_data.order_items)) return '0.00'
        const total = this.invoice_data.order_items.reduce((a, b) => a + Number(b.net_value || 0) + Number(b.vat_value || 0), 0)
        return Number(total).toFixed(2)
      },
      totalOrderValue() {
        if (!this.invoice_data) return '0.00'
        const itemsTotal = Array.isArray(this.invoice_data.order_items)
          ? this.invoice_data.order_items.reduce((a, b) => a + Number(b.net_value || 0) + Number(b.vat_value || 0), 0)
          : 0
        const addCostsTotal = Array.isArray(this.invoice_data.add_costs)
          ? this.invoice_data.add_costs.reduce((acc, obj) => acc + Number(obj.amount || 0) * (1 + (Number(obj.vat_percent || 0) / 100)), 0)
          : 0
        return Number(itemsTotal + addCostsTotal).toFixed(2)
      },
      async testPrint() {
        const d = new Printd()
        d.printURL('/pages/product-orders/167', ({ launchPrint }) => {

          // fire printing!
          launchPrint()
        })
      },
      async getInvoiceDetails() {
        await this.$vs.loading({
          container: '#rm-order-po-pdf-pop-up',
          scale: 0.45
        })
        try {
          const {data} = (await CustomerRepository.getProductOrderConfirmationData(this.product_order_secret_code)).data
          this.invoice_data =  data

        } catch (e) {
          this.showWarningMessage('Something went wrong. Please try again!')
        }
        this.$vs.loading.close('#rm-order-po-pdf-pop-up > .con-vs-loading')
      },
      onClickPrint() {
         const d = new Printd()
        const styles = `
          html,
body {
  -webkit-print-color-adjust: exact !important;
}
@media print {
  body {
    zoom: 75%;
  }
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

a {
  color: #0087C3;
  text-decoration: none;
}

body {
  position: relative;
  margin: 0 auto;
  color: #000000;
  background: #FFFFFF;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
}

div#full-wrap {
  width: 40cm;
  max-width: 100%;
  margin: 0 auto;
}

h4 {
  font-size: 24px;
}

p {
  font-size: 16px;
  margin: 0;
}

.sml {
  font-size: 14px;
}

main {
  padding: 0px 10px 20px 10px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
  font-size: 13px;

}

table th,
table td {
  padding: 20px;
  text-align: center;
  vertical-align: top;
}

table td:nth-child(2) {
  word-break: break-all;
}

table th {
  white-space: nowrap;
  font-weight: normal;
  color: #000;
}

table td {
  text-align: left;
}

table.txt-center td {
  text-align: center;
}

table.txt-left td {
  text-align: left;
}

table.txt-right td {
  text-align: right;
}


div#user-top {
  width: 100%;
  margin: 2em auto 2em auto;
}

div#user-top table {
  margin: 0 auto 0 auto;
  text-align: center;
  width: 100%;
}

div#user-top table td {
  padding: 5px 20px;
  font-size: 14px;
}

div#user-top .head {
  vertical-align: middle;
  text-align: center;

}

table#in-tbl {
  width: 100%;

}

table#in-tbl td {
  border: 2px solid #000;

}

table#in-tbl thead td.headtd {
  border: 2px solid #000;
  border-bottom-width: 0px;

}

table#in-tbl tbody td.bodytda {
  border: 2px solid #000;
  border-top-width: 0px;
  border-right-width: 0px;

}

table#in-tbl tbody td.bodytdb {
  border: 2px solid #000;
  border-top-width: 0px;
  border-left-width: 0px;

}

table#in-tbl tbody td.bodytd {
  border: 2px solid #000;
  border-top-width: 0px;


}

table#main-tbl thead td {
  border: 3px solid #000;
  border-bottom-width: 2px;

}

table#main-tbl tbody td.toptd {
  border: 3px solid #000;
  border-top-width: 0px;
  padding: 5px;
  width: 50%;
}

table#main-tbl tbody td.toptd table#in-tbl {
  min-height: 15em;
}

table#content-tbl th,
table#content-tbl td {
  border: 2px solid #000;
  font-size: 13px !important;
  text-align: center;
}


/* table#content-tbl td[rowspan="1"] {
    height: 300px;
} */


table#content-tbl td.htd {
  height: 350px;
}

td.no-bd {
  border-left: 0px !important;
  border-bottom: 0px !important;
}

table.no-bd-tbl td {
  border: 0px !important;

}

table.no-bd-tbl {
  margin-bottom: 0 !important;
}

.align-left {
  text-align: left !important;
}

.align-center {
  text-align: center !important;
}

.align-right {
  text-align: right !important;
}

footer {
  padding: 0 30px;
}

.p-0 {
  padding: 0 !important;
}

.m-0 {
  margin: 0 !important;
}

.bd-b-0 {
  border-bottom-width: 0px !important;
}

.bd-r-0 {
  border-right-width: 0px !important;
}

.bd-l-0 {
  border-left-width: 0px !important;
}
        `
        d.print(document.getElementById('myelement'), [styles])
      },
      async generateReportPromtActive() {
        try {
          const { data } = (await DropDownRepository.getCustomerUsersDropdownList(this.invoice_data.customer_id)).data
          this.customer_list = data
        } catch (e) {

        }
        this.open = false
        this.activePrompt = true
      },
      async generateReport() {
        this.open = true
        this.activePrompt = false
        const vue = this
        this.$vs.loading()
        // setTimeout(async () => {
        //   await this.$refs.html2Pdf.generatePdf()
        // }, 500)
        try {
          await CustomerRepository.orderConfirmationSentCustomer(this.id, { user_email: this.customer_email})
          await vue.$parent.refreshData()
          this.showSuccessMessage('Sales order confirmation sent successfully')
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async pdfBeforeDownloaded({html2pdf, options, pdfContent}) {
        this.$vs.loading()
        const vm = this
        await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then(async (pdf) => {
          const payload = { file: btoa(pdf.output()), file_name: vm.invoice_data.order_code, path: 'order/invoice' }
          const file_name = (await FileRepository.uploadBase64File(payload)).data.data.file
          try {
            await CustomerRepository.orderConfirmationSentCustomer(vm.id, { user_email: vm.customer_email, attachment: file_name })
            vm.showSuccessMessage('Sales order confirmation sent successfully')
          } catch (e) {
            vm.convertAndNotifyError(e)
          }
        })
        vm.$parent.refreshData()
        vm.$vs.loading.close()
      },
      totalCalculator() {
        let total = 0;
        this.order_details.items.forEach((m) => {
          if (!!m.price) {
            total = total + Number(m.value)
          }
        })
        return total.toFixed(2)
      },
    },
    components: {
      'v-select': vSelect,
      VueHtml2pdf
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
html,
body {
  -webkit-print-color-adjust: exact !important;
}
/*@media print {*/
/*  body {*/
/*    zoom: 50%;*/
/*  }*/
/*}*/

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

a {
  color: #0087C3;
  text-decoration: none;
}

body {
  position: relative;
  margin: 0 auto;
  color: #000000;
  background: #FFFFFF;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
}

div#full-wrap {
  width: 40cm;
  max-width: 100%;
  margin: 0 auto;
}

h4 {
  font-size: 24px;
}

p {
  font-size: 16px;
  margin: 0;
}

.sml {
  font-size: 14px;
}

main {
  padding: 0px 10px 20px 10px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  margin-bottom: 20px;
  font-size: 13px;

}

table th,
table td {
  padding: 20px;
  text-align: center;
  vertical-align: top;
}

table td:nth-child(2) {
  word-break: break-all;
}

table th {
  white-space: nowrap;
  font-weight: normal;
  color: #000;
}

table td {
  text-align: left;
}

table.txt-center td {
  text-align: center;
}

table.txt-left td {
  text-align: left;
}

table.txt-right td {
  text-align: right;
}


div#user-top {
  width: 100%;
  margin: 2em auto 2em auto;
}

div#user-top table {
  margin: 0 auto 0 auto;
  text-align: center;
  width: 100%;
}

div#user-top table td {
  padding: 5px 20px;
  font-size: 14px;
}

div#user-top .head {
  vertical-align: middle;
  text-align: center;

}

table#in-tbl {
  width: 100%;

}

table#in-tbl td {
  border: 2px solid #000;

}

table#in-tbl thead td.headtd {
  border: 2px solid #000;
  border-bottom-width: 0px;

}

table#in-tbl tbody td.bodytda {
  border: 2px solid #000;
  border-top-width: 0px;
  border-right-width: 0px;

}

table#in-tbl tbody td.bodytdb {
  border: 2px solid #000;
  border-top-width: 0px;
  border-left-width: 0px;

}

table#in-tbl tbody td.bodytd {
  border: 2px solid #000;
  border-top-width: 0px;


}

table#main-tbl thead td {
  border: 3px solid #000;
  border-bottom-width: 2px;

}

table#main-tbl tbody td.toptd {
  border: 3px solid #000;
  border-top-width: 0px;
  padding: 5px;
  width: 50%;
}

table#main-tbl tbody td.toptd table#in-tbl {
  min-height: 15em;
}

table#content-tbl th,
table#content-tbl td {
  border: 2px solid #000;
  font-size: 13px !important;
  text-align: center;
}


/* table#content-tbl td[rowspan="1"] {
    height: 300px;
} */


table#content-tbl td.htd {
  height: 300px;
}

td.no-bd {
  border-left: 0px !important;
  border-bottom: 0px !important;
}

table.no-bd-tbl td {
  border: 0px !important;

}

table.no-bd-tbl {
  margin-bottom: 0 !important;
}

.align-left {
  text-align: left !important;
}

.align-center {
  text-align: center !important;
}

.align-right {
  text-align: right !important;
}

footer {
  padding: 0 30px;
}

.p-0 {
  padding: 0 !important;
}

.m-0 {
  margin: 0 !important;
}

.bd-b-0 {
  border-bottom-width: 0px !important;
}

.bd-r-0 {
  border-right-width: 0px !important;
}

.bd-l-0 {
  border-left-width: 0px !important;
}
</style>
